import React, { useEffect, useState } from 'react';

import Toast from '@/src/components/common/Toast/Toast';

import { useMoveFolder } from '../../api/moveFolder';
import { useLibraryListStore } from '../../store/library-list.store';

export const useUndoMoveToast = () => {
  const undoData = useLibraryListStore((s) => s.pendingUndo);
  const clearUndoToast = useLibraryListStore((s) => s.clearUndoToast);

  const moveFolderMutation = useMoveFolder();

  const [openToast, setOpenToast] = useState(false);
  const [toastType, setToastType] = useState<'undo' | 'undone' | ''>();

  useEffect(() => {
    if (undoData) {
      setToastType('undo');
      setOpenToast(true);
    }
  }, [undoData]);

  const handleRevert = async () => {
    if (!undoData) return;

    await moveFolderMutation.mutateAsync({
      itemIdsVersioned: undoData.itemIdsVersioned,
      parentId: undoData.previousParentId === undefined ? null : undoData.previousParentId,
    });

    setToastType('undone');
    setOpenToast(true);
    clearUndoToast();
  };

  const handleClose = () => {
    setOpenToast(false);
    setToastType('');
    clearUndoToast();
  };

  const toastElement = (
    <Toast open={openToast} onClose={handleClose} timer={10000}>
      {toastType === 'undo' && undoData ? (
        <span>
          {undoData.itemIdsVersioned.length} item/s moved.{' '}
          <a onClick={handleRevert}>Click here to Undo this action.</a>
        </span>
      ) : (
        <span>Action Undone!</span>
      )}
    </Toast>
  );

  return { toastElement };
};
